import SideMenu from '@/containers/side-menu/SideMenu.vue'
import ReportEmployeeSalesList from '@/pages/report-employee-sales-list/ReportEmployeeSalesList'

export default {
  path: '/report-employee-sales',
  name: 'ReportEmployeeSalesList',
  components: {
    mainContent: ReportEmployeeSalesList,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'report-employee-sales'
    },
    breadcrumb: {
      title: 'Fechamento Fiscal/PDV',
      paths: [
        { title: 'Relatórios' },
      ]
    }
  }
}